module.exports = __webpack_public_path__ + "static/img/block-0.c3516448.png";